<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs v-if="fill === 'gradient'">
      <linearGradient id="gradient" x1="100%" y1="0%" x2="100%" y2="100%">
        <stop offset="0" stop-color="#FF00D6" />
        <stop offset="100%" stop-color="#0072DB" />
      </linearGradient>
    </defs>
    <path
      d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
      :fill="fill === 'gradient' ? 'url(#gradient)' : fill"
      fill-opacity="0.87"
    />
  </svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String,
      default: "white",
    },
  },
};
</script>
